import HardwareSubmissionManagement from "../../components/admin/HardwareSubmissionManagement";

const HardwareSubmissionPage = () => {
  return <HardwareSubmissionManagement />;
};

export default HardwareSubmissionPage;
